import { render, staticRenderFns } from "./ManterMinuta.vue?vue&type=template&id=88c2b646&scoped=true&"
import script from "./ManterMinuta.vue?vue&type=script&lang=js&"
export * from "./ManterMinuta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c2b646",
  null
  
)

export default component.exports